module.exports = __webpack_public_path__ + "img/changjing2.546e799f.png";